/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { db_DropdownTravelStatus } from '../models/db_DropdownTravelStatus';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class TravelStatuses {
    /**
     * Get a list of travel statuses
     * @returns db_DropdownTravelStatus OK
     * @throws ApiError
     */
    public static listTravelStatuses(): CancelablePromise<Array<db_DropdownTravelStatus>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/travel-statuses',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                500: `Internal Server Error`,
            },
        });
    }
}
